import { createWebHistory, createRouter } from "vue-router";
import ContactPage from '@/pages/contact.vue';
import PrivacyPolicy from '../pages/privacy-policy.vue'
import TermsOfService from '../pages/terms-of-service.vue'

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/pages/home.vue"),
  },
  {
    path: "/comingsoon",
    name: "Comingsoon",
    component: () => import("@/pages/comingsoon.vue"),
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/pages/maintenance.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "Error",
    component: () => import('@/pages/error.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfService
  }
];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;